



































import { Component, Mixins } from 'vue-property-decorator'
import SalesReportMixin from '@/views/Reports/Report/SalesReport/SalesReportMixin'

@Component
export default class OverviewPerBranchInformation extends Mixins(SalesReportMixin) {
}
